import { Component } from "react";

import moment from "moment";
import axios from "axios";
import { Box, Typography } from "@mui/material";

import schema from "./schema";

import Formizo from "Components/LabIZO/Formizo";
import { HStack, Spacer, VStack } from "Components/LabIZO/Stackizo";
import { Accessor, store, ErrorX, ColorX } from "static";
import { StyledButton } from "Components/LabIZO/Stylizo";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DATA_LINK, backendConnector } from "connectors";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} location={location} navigate={navigate} params={params} />;
  }
  return ComponentWithRouterProp;
}
class TrainCreate extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      defaultDateRange: [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
      steps: [
        {
          label: "Create Scenario",
        },
        {
          label: "Data Tagging",
        },
        {
          label: "Training",
        },
        {
          label: "Verification",
        },
      ],
      activeStep: 0,
    };
  }

  _initCount = async () => {
    this.setState({
      totalEntries: 0,
    });
  };

  componentDidMount() {
    this._setAllStates(() => {
      this._initCount();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(TrainCreate.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  onMountStepizo = (callbacks) => {
    this.MountStepizo = callbacks;
  };

  onMountFormizo = (callbacks) => {
    this.MountFormizo = callbacks;
  };

  _onSubmit = async (formprops) => {
    let { onQuitRefresh } = this.props;
    const url = DATA_LINK.TrainingAdd;
    const importURL = DATA_LINK.TrainingImport;
    const isUploadImport = formprops.source === "import";
    try {
      store.isLoading(true);
      const { Success, payload } = isUploadImport
        ? await backendConnector.upload(importURL, formprops.Options.ImportInfo, formprops)
        : await backendConnector.post(url, {
            ...formprops,
          });

      store.isLoading(false);
      console.log(isUploadImport ? importURL : url, payload);

      if (Success) {
        if (onQuitRefresh) {
          const trainingID = formprops.alias;
          onQuitRefresh(trainingID);
        } else {
          const { navigate } = this.props;
          debugger;
          navigate("/Training");
        }
      } else {
        ErrorX.Handle(payload.message || "");
        store.Alert(payload.message || "", "error");
      }
    } catch (e) {
      store.isLoading(false);
      ErrorX.Handle(e);
    }
  };

  _onChange = async (formValue, name, value) => {
    if (name === "source") {
      if (value === "log") {
        if (this.state.logTotalEntries == undefined) {
          this._getCount(formValue.DateRange);
        }
        this.setState({
          source: "log",
        });
      }
      if (value === "import") {
        this.setState({
          source: "import",
        });
      }
    }
    if (name === "DateRange") {
      this._getCount(value);
    }
    if (name === "Options.ImportInfo") {
      this._getImportCount(value);
    }
  };

  _getImportCount = async (excelFile) => {
    const url = DATA_LINK.TrainingImportInfo;
    try {
      const { Success, payload } = await backendConnector.upload(url, excelFile);

      if (Success === true) {
        this.setState({
          importTotalEntries: payload.doc_count,
        });
      } else {
        ErrorX.Handle(payload.message || "");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  _getCount = async (DateRange) => {
    const url = DATA_LINK.ConvlogDBInfo;
    const payloadOut = {
      addOns: {
        DateRange,
      },
    };

    try {
      const { Success, payload } = await backendConnector.post(url, {}, { DateRange });
      console.log(url, payload);

      if (Success === true) {
        this.setState({
          logTotalEntries: payload.doc_count,
        });
      } else {
        ErrorX.Handle(payload.message || "");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderCreateButton() {
    return (
      <StyledButton
        key="next"
        onClick={() => {
          this.MountFormizo.Submit();
        }}
        theme={{
          color: "white",
          background: ColorX.GetColorCSS("Primary"),
          hover: {
            background: ColorX.GetColorCSS("Primary2"),
          },
          boxShadow: "transparent",
          borderRadius: "0px",
          width: "200px",
        }}
      >
        <HStack>
          <Typography>CREATE SCENARIO</Typography>
          <Spacer />
          <i className="fas fa-arrow-right" />
        </HStack>
      </StyledButton>
    );
  }

  renderTraining() {}

  renderTagging() {}

  renderCreate() {
    let { DateRange } = this.props;
    const { logTotalEntries, importTotalEntries, source } = this.state;
    const totalEntries = source == "log" ? logTotalEntries : importTotalEntries;
    const { defaultDateRange } = this.state;
    return (
      <VStack justifyContent="flex-start">
        <Typography
          style={{
            textAlign: "left",
            width: "100%",
            fontSize: 20,
            fontFamily: "Segoe UI",
            color: ColorX.GetColorCSS("Primary"),
            margin: "5px 0",
          }}
        >
          CREATE NEW TRAINING SCENARIO
        </Typography>
        <HStack alignItems="flex-start" marginY={3}>
          <Formizo
            height="550px"
            width="600px"
            schema={schema.Training}
            buttons={[this.renderCreateButton()]}
            onMounted={this.onMountFormizo}
            onSubmit={this._onSubmit}
            onChange={this._onChange}
            fieldStyle="grid"
            labelJustify="flex-start"
            buttonAlign="right"
            onInvalid={() => {
              store.Alert("The data is invalid.", "warning");
            }}
            defaultValue={{
              DateRange: defaultDateRange,
            }}
            addOns={{
              totalEntries: totalEntries,
            }}
          />
        </HStack>
      </VStack>
    );
  }

  renderStep() {
    let { activeStep } = this.state;
    return (
      <Box>
        <Box display={activeStep === 0 ? undefined : "none"}>{this.renderCreate()}</Box>
        <Box display={activeStep === 1 ? undefined : "none"}>{this.renderTagging()}</Box>
        <Box display={activeStep === 2 ? undefined : "none"}>{this.renderTraining()}</Box>
      </Box>
    );
  }

  render() {
    return <VStack>{this.renderStep()}</VStack>;
  }
}

export default withRouter(TrainCreate);
